<ng-container *ngIf="bundleTemplate && servicePlan">
  <div class="d-flex flex-column align-items-center justify-content-center mb-4">
    <span
      class="ds-color--grey-2 text-center">{{priceDisplayByCurrency?.labels?.top || priceDisplay?.labels?.top}}</span>
    <div class="d-flex justify-content-center">
      <ng-container *ngIf="priceDisplayByCurrency; else noPriceTemplate">
        <div
          class="ds-color--gold--dark ds-body me-1 d-flex align-items-center">{{priceDisplayByCurrency?.labels?.main?.currency}}</div>
        <ng-container
          *ngIf="cutPriceVisually(priceDisplayByCurrency?.labels?.main?.value) as mainLabel"
        >
          <div class="ds-color--gold--dark ds-heading--xl"
          >{{mainLabel[0]}}</div>
          <div *ngIf="mainLabel.length > 1" class="ds-color--gold--dark ds-body--l d-flex align-items-end mb-1"
          >{{mainLabel[1]}}</div>
        </ng-container>
      </ng-container>
      <ng-template #noPriceTemplate>
        <div
          class="ds-color--gold--dark ds-heading--xl text-center"
          data-cy="priceUponRequest"
        >
          <ng-container *ngIf="priceDisplay?.labels?.main; else priceUponRequest">
            {{priceDisplay.labels.main}}
          </ng-container>
          <ng-template #priceUponRequest>
            <ng-container *ngIf="!isSapProduct">
              {{'productDetails.priceUponRequest' | cxTranslate}}
            </ng-container>
          </ng-template>
        </div>
      </ng-template>
      <ng-container
        *ngIf="!priceDisplayByCurrency && isSapProduct && priceDisplay?.priceNotAvailable">
        <div
          class="ds-color--black ds-body--l text-center"
          data-cy="priceNotAvailable"
        >
          {{ 'productDetails.priceNotAvailable' | cxTranslate }}
        </div>
      </ng-container>
      <div *ngIf="tooltipVisible()" class="d-flex align-items-end ms-1 mb-1">
        <ds-tooltip
          [content]="tooltipContent"
          class="ds-tooltip pricing-tooltip"
          placement="end"
        ></ds-tooltip>
      </div>

    </div>

    <span
      *ngFor="let sub of (priceDisplayByCurrency?.labels?.subs || priceDisplay?.labels?.subs)"
      [innerHTML]="sub"
      class="ds-body ds-color--grey-1 text-center"
    ></span>
  </div>

  <dcp-cta-form
    [bundleTemplate]="bundleTemplate"
    [fullWidth]="true"
    [outlineButtons]="false"
    [slmTransactionTypes]="priceDisplay?.labels?.ctas"
  ></dcp-cta-form>
  <div class="pb-5"></div>
</ng-container>
<ng-template #tooltipContent>
  <dcp-partner-plans-and-pricing-tooltip
    [ratePlans]="ratePlans"
  ></dcp-partner-plans-and-pricing-tooltip>
</ng-template>
